export const mpsRouteNames = {
  root: '/',
  app: 'app',
  auth: 'auth',
  login: 'login',
  logout: 'logout',
};
